import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { Props } from './UsedSpacePostpaidModal.types';

export const renderUserSpacePostpaidModal = (data: Props) => {
    openPopupHelper({
        popupName: popupNames.USED_SPACE_POSTPAID_MODAL,
        data: {
            ...data,
            onCloseClick: data.onClose,
        },
    });
};
